module.exports = __webpack_public_path__ + "img/11-02.b2510e80.jpg";